import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {sumBy} from 'lodash';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';

class ReceptionsOrdersList extends Component {
  renderReceptionsOrders() {
    const {loading, ordersList} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!ordersList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={3}>No hay datos</Table.Cell>
        </Table.Row>
      );
    }
    return ordersList.map((element, index) => {
      const dateFormatted = element.date ?
        moment(element.date).format(dateFormatReservation) :
        '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.invoice}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotals() {
    const {ordersList} = this.props;
    const totalQuantity = sumBy(ordersList, 'quantity') || 0;
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={2}>TOTAL</Table.Cell>
        <Table.Cell textAlign='center'>{totalQuantity}</Table.Cell>
      </Table.Row>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <div className='title-bar'>
          <div className='title'>
            <h2>Recibido</h2>
          </div>
        </div>

        <Table striped className='scrollable-body'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
      
          <Table.Body>
            {this.renderReceptionsOrders()}
            {this.renderTotals()}
          </Table.Body>
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partWatching.loadingReceptionsOrders,
    'ordersList': state.partWatching.receptionsOrders,
  };
};

export default connect(mapStateToProps, {
})(ReceptionsOrdersList);
